<template>
  <div class="w-full px-6 py-8 box-border" v-loading="loading">
    <div class="mb-4 px-4 pb-3 box-border bg-card-bg-gray">
      <header class="leading-6 text-medium text-theme-black-850">使用须知：</header>
      <ul class="flex flex-col text-medium text-theme-black-850">
        <li class="leading-6">1. 发送成功后，可以查看已发短信的进度</li>
        <li class="leading-6">2. 给异常的手机号（包括停机，空号等）发送短信，也会扣除本次发送短信</li>
        <li class="leading-6">3. 根据运营商规定，{{ smsConstantSize }} 个字符为1条短信，1 个汉字或字母均占 1 个字符</li>
        <li class="leading-6">4. 短信运营商将对群发短信进行内容审核，审核通过后短信才能正式发送</li>
      </ul>
    </div>
    <data-table
      cell-class-name="truncate-table-cell-wrap"
      align="left"
      :data="list"
      :columns="columns"
      @row-click="rowSelectHandle"
    >
      <template #content="{ row }">
        <div class="whitespace-normal">{{ row.content }}</div>
      </template>
      <template #action="{ row }">
        <el-radio v-model="tempCheck" :label="row.id">
          <div />
        </el-radio>
      </template>
    </data-table>
    <div class="w-full mt-3 mb-1 flex items-center justify-between">
      <div class="flex items-center">
        <el-popover placement="bottom" trigger="hover" popper-class="min-w-0 p-0">
          <template #reference>
            <el-button size="small" class="text-medium">自定义短信</el-button>
          </template>
          <div class="shadow-theme card-box flex flex-col items-center justify-center">
            <div class="qr-box bg-card-bg-gray">
              <img class="w-full h-full" src="/assets/img/code/Mrs.Chai.png" />
            </div>
            <span class="mt-4 text-small text-black opacity-45">微信扫码联系定制</span>
          </div>
        </el-popover>
        <!-- <p class="ml-3 text-medium text-theme-black-650">现有短信 <span class="text-danger">{{smsSize}}</span> 条</p> -->
      </div>
      <p class="text-medium text-theme-black-650">
        短信内容包含 <span class="text-danger">{{ smsContent.length }}</span> 个字符， 发送给
        <span class="text-danger">{{ selectSize }}</span> 位收信人，将消费
        <span class="text-danger">{{ spendBalance }}</span> 条短信
      </p>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import GlobalConfig from '@/global/config'
import { getAnswerUrl } from '@/assets/js/utils'
import { getSubShortLink, checkRewardInfo, getSmsTemps } from '@/api/wenjuan/publish'
import { fridayMixins } from '@/mixins/publish'
// import { getCompanyInfo } from '@/api/surveywork/captialMessage';
import { smsColumns, smsTempStatus, getTempObjectFn, CONSTANT_SMS_SIZE } from '../config/sms-sending'

export default {
  name: 'StepSms',
  mixins: [fridayMixins],
  components: {
    DataTable
  },
  inject: {
    source: {
      default: () => ({})
    }
  },
  data() {
    return {
      smsConstantSize: CONSTANT_SMS_SIZE,
      list: [],
      columns: smsColumns,
      tempCheck: null,
      tempObj: null,
      infoLoading: false,
      tempLoading: false,
      shortUrl: '',
      awardInfo: {}
      // smsSize: 0,
    }
  },
  created() {
    this.getInfo()
    this.getSmsTemplate()
    // this.getCurrentSmsSize();
  },
  activated() {
    // this.getInfo()
    // this.getSmsTemplate()
    this.source.smsCheck = this.tempCheck
    this.source.smsContent = this.smsContent
    this.source.smsMoney = this.smsMoney
  },
  watch: {
    tempCheck(id) {
      this.source.smsCheck = id
    },
    smsContent(content) {
      this.source.smsContent = content
    },
    smsMoney(money) {
      this.source.smsMoney = money
    }
  },
  computed: {
    loading() {
      return this.infoLoading || this.tempLoading
    },
    spendBalance() {
      const count = Math.ceil(this.smsContent.length / CONSTANT_SMS_SIZE)
      return parseInt(this.selectSize * count)
    },
    selectSize() {
      return this.source?.selectTotal || 0
    },
    smsContent() {
      if (this.tempCheck === undefined || this.tempCheck === null || this.tempObj === null) {
        return ''
      }
      const { title } = this.$store.getters
      const fn = this.tempObj[`smsTempText${this.tempCheck}`]
      if (typeof fn === 'function') {
        const [endCode = ''] = this.shortUrl.match(/\/\w+$/) || []
        const code = endCode.replace('/', '')
        return fn({
          title: title ?? '',
          code,
          money: this.smsMoney,
          companyname: GlobalConfig.getCompanyName(),
          timesStr: this.getTimesStr()
        })
      }
      return ''
    },
    smsMoney() {
      if (this.tempCheck === smsTempStatus.HAVE_REWARD) {
        const info = this.awardInfo.award ? this.awardInfo.award : this.awardInfo
        const { randomRedEnvelope, rdMin, rdMax, amount } = info
        const money = randomRedEnvelope ? `${rdMin ?? 0}-${rdMax ?? 0}` : amount ?? 0
        return `${money}元`
      }
      return ''
    }
  },
  methods: {
    // getCurrentSmsSize() {
    //   getCompanyInfo().then((res) => {
    //     const { balance } = res?.data;
    //     this.smsSize = balance || 0;
    //   }).catch(() => {
    //     this.$message.error('获取可用短信数失败');
    //   });
    // },
    // 发送确认
    getInfo() {
      const surveyId = GlobalConfig.getSurveyId()
      // const url = getAnswerUrl('computer', { surveyId })
      const url = getAnswerUrl('mobile', { surveyId })
      const sslPM = getSubShortLink({ url })
        .then(res => res?.data?.data || '')
        .catch(() => {})
      const criPM = checkRewardInfo(surveyId)
        .then(res => res?.data?.data || {})
        .catch(() => {})
      this.infoLoading = true
      this.source.nextLoading = true
      Promise.all([sslPM, criPM])
        .then(([shortUrl, awardInfo]) => {
          this.shortUrl = shortUrl ?? ''
          this.awardInfo = awardInfo || {}
        })
        .catch(() => {
          this.$message.error('获取支付信息失败')
        })
        .finally(() => {
          this.infoLoading = false
          this.source.nextLoading = false
        })
    },
    rowSelectHandle(row) {
      this.tempCheck = row.id
    },
    getList(temps = []) {
      if (this.tempObj === null) return
      const prefix = 'smsTempText'
      const tempNameMap = Object.fromEntries(temps.map(m => [m.id, m.templateName]))
      const baseList = [smsTempStatus.NO_REWARD, smsTempStatus.HAVE_REWARD, smsTempStatus.NORMAL].map(m => {
        const fn = this.tempObj[`${prefix}${m}`]
        const content = typeof fn === 'function' ? fn() : ''
        return {
          id: m,
          name: tempNameMap[m] || '',
          content
        }
      })

      const companyId = GlobalConfig.getCompanyId()
      let pushList = []
      if (companyId == '7') {
        // 清研
        pushList = [
          smsTempStatus.QY1,
          smsTempStatus.QY2,
          smsTempStatus.QY4,
          smsTempStatus.QY17,
          smsTempStatus.QY26,
          smsTempStatus.QY27,
          smsTempStatus.QY28,
          smsTempStatus.QY29,
          smsTempStatus.QY31,
          smsTempStatus.QY32,
          smsTempStatus.QY33,
          smsTempStatus.QY34,
          smsTempStatus.QY35,
          smsTempStatus.QY36,
          smsTempStatus.QY37,
          smsTempStatus.QY38,
          smsTempStatus.QY40,
          smsTempStatus.QY41,
          smsTempStatus.QY42,
          smsTempStatus.QY43,
          smsTempStatus.QY44,
          smsTempStatus.QY45,
          smsTempStatus.QY46,
          smsTempStatus.QY47,
          smsTempStatus.QY48,
          smsTempStatus.QY49,
          smsTempStatus.QY50,
          smsTempStatus.QY417,
        ]
      } else if (companyId == '195') {
        // 经纬
        pushList = [
          smsTempStatus.JW30
        ]
      } else if (companyId == '57') {
        // 诚凯
        pushList = [
          smsTempStatus.CK39
        ]
      }

      for (const m of pushList) {
        const fn = this.tempObj[`${prefix}${m}`]
        const content = typeof fn === 'function' ? fn() : ''
        if (content) {
          baseList.push({
            id: m,
            name: tempNameMap[m] || '',
            content
          })
        }
      }

      const companyName = GlobalConfig.getCompanyName()
      if (companyName && companyName !== '个人身份') {
        const fn = this.tempObj[`${prefix}${smsTempStatus.COMPANY}`]
        const content = typeof fn === 'function' ? fn() : ''
        if (content) {
          baseList.push({
            id: smsTempStatus.COMPANY,
            name: tempNameMap[smsTempStatus.COMPANY] || '',
            isCompany: true,
            content
          })
        }
      }
      this.list = baseList
      if (baseList.length > 0) {
        if (this.source.smsCheck) {
          this.tempCheck = this.source.smsCheck
        } else {
          this.tempCheck = baseList[0].id
        }
      }
    },
    getSmsTemplate() {
      this.tempLoading = true
      getSmsTemps()
        .then(res => {
          const temps = res.data.data || []
          this.tempObj = getTempObjectFn(temps)
          this.getList(temps)
        })
        .catch(e => {
          this.$message.error('获取短信模板失败')
        })
        .finally(() => {
          this.tempLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.qr-box {
  width: 100px;
  height: 100px;
}
.card-box {
  width: 132px;
  height: 160px;
}
</style>
